import { Environment } from 'dashboard/models/environment';
import { TriggerType } from 'dashboard/models/trigger';
import { WorkflowVersion } from 'dashboard/models/workflow-version';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';

interface WorkflowVersionsPayload {
  workflowVersions: WorkflowVersion[];
  environment: Environment;
  paginationParams: PaginationParams;
}

export interface WorkflowVersionsFilterParams {
  workflowIds: string[];
  'trigger-type'?: TriggerType;
}

interface WorkflowVersionFiltersPayload {
  filters: WorkflowVersionsFilterParams;
}

interface CurrentPagePayload {
  currentPage: number;
}

interface PageSizePayload {
  pageSize: number;
}

export type WorkflowVersionsActions =
  | Action<WorkflowVersionsActionType.SetWorkflowVersions, WorkflowVersionsPayload>
  | Action<WorkflowVersionsActionType.ClearWorkflowVersions>
  | Action<WorkflowVersionsActionType.SetWorkflowVersionFilters, WorkflowVersionFiltersPayload>
  | Action<WorkflowVersionsActionType.SetCurrentPage, CurrentPagePayload>
  | Action<WorkflowVersionsActionType.SetPageSize, PageSizePayload>;

export enum WorkflowVersionsActionType {
  SetWorkflowVersions = 'workflow-versions/SET_WORKFLOW_VERSIONS',
  ClearWorkflowVersions = 'workflow-versions/CLEAR_WORKFLOW_VERSIONS',
  SetWorkflowVersionFilters = 'workflow-versions/SET_WORKFLOW_VERSION_FILTERS',
  SetCurrentPage = 'workflow-versions/SET_CURRENT_PAGE',
  SetPageSize = 'workflow-versions/SET_PAGE_SIZE',
}

export function setWorkflowVersions(
  workflowVersions: WorkflowVersion[],
  paginationParams: PaginationParams,
) {
  return {
    payload: {
      workflowVersions,
      paginationParams,
    },
    type: WorkflowVersionsActionType.SetWorkflowVersions,
  };
}

export function clearWorkflowVersions() {
  return {
    type: WorkflowVersionsActionType.ClearWorkflowVersions,
  };
}
export function setWorkflowVersionFilters(filters: Partial<WorkflowVersionsFilterParams>) {
  return {
    payload: {
      filters,
    },
    type: WorkflowVersionsActionType.SetWorkflowVersionFilters,
  };
}

export function setCurrentPage(currentPage: number) {
  return {
    payload: {
      currentPage,
    },
    type: WorkflowVersionsActionType.SetCurrentPage,
  };
}

export function setPageSize(pageSize: number) {
  return {
    payload: {
      pageSize,
    },
    type: WorkflowVersionsActionType.SetPageSize,
  };
}
